import { render, staticRenderFns } from "./portait-libray.vue?vue&type=template&id=6db316af&scoped=true&"
import script from "./portait-libray.vue?vue&type=script&lang=ts&"
export * from "./portait-libray.vue?vue&type=script&lang=ts&"
import style0 from "./portait-libray.vue?vue&type=style&index=0&id=6db316af&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db316af",
  null
  
)

export default component.exports